export default __webpack_public_path__ + "static/media/Metso_Logo_Black_RGB.c584544f.svg";